import './App.css';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import ExperiencePage from './ExperiencePage';
import { CURRENT, EDUCATION, ENTRIES, INCOMING, PREVIOUS, PROJECTS } from './experienceData';

const NAME = 'Akanksh Divyananda';
const THEME_VARS = { bg: '--bg', ink: '--ink', text: '--text', dim: '--text-dim', tile: '--tile' };

const Chevron = () => (
  <svg className="chevron" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </svg>
);

const NowCard = ({ entry, label, detail }) => (
  <a className="now-card" href={`#/${entry.id}`}>
    <span className="now-card-top">
      <img src={entry.logo} alt="" />
      <Chevron />
    </span>
    <span className="now-label">{label}</span>
    <span className="now-org">{entry.org}</span>
    <span className="now-detail">{detail}</span>
  </a>
);

const Home = () => (
  <>
    <h1 className="welcome">Welcome</h1>

    <section className="now">
      <NowCard entry={CURRENT} label="Currently at" detail={CURRENT.role} />
      <NowCard entry={INCOMING} label="Incoming" detail={INCOMING.dates} />
    </section>

    <p className="intro">
      Hi, I’m Akanksh. I’m a software engineer and computer science master’s student at UIUC. I
      build backend and AI systems.
    </p>

    <section className="group">
      <h2>Previously</h2>
      {PREVIOUS.map((entry) => (
        <a className="row" href={`#/${entry.id}`} key={entry.id}>
          <span className="row-logo">
            <img src={entry.logo} alt="" />
          </span>
          <span className="row-body">
            <span className="row-title">{entry.org}</span>
            <span className="row-meta">
              {entry.role}, {entry.dates}
            </span>
            <span className="row-summary">{entry.summary}</span>
          </span>
          <Chevron />
        </a>
      ))}
    </section>

    <section className="group">
      <h2>Projects</h2>
      {PROJECTS.map((project) => (
        <p className="plain" key={project.org}>
          <a href={project.href} target="_blank" rel="noopener noreferrer">
            {project.org}
          </a>
          <span className="row-meta">{project.dates}</span>
          <span className="row-summary">{project.summary}</span>
        </p>
      ))}
    </section>

    <section className="group">
      <h2>Education</h2>
      {EDUCATION.map((school) => (
        <p className="plain" key={school.org}>
          <span className="row-title">{school.org}</span>
          <span className="row-meta">{school.detail}</span>
        </p>
      ))}
    </section>

    <section className="group">
      <h2>Resume</h2>
      <object className="resume-embed" data="/resume.pdf#toolbar=0&view=FitH" type="application/pdf" aria-label="Akanksh Divyananda's resume">
        <p>
          Your browser can't preview PDFs here. <a href="/resume.pdf">Open the resume</a> instead.
        </p>
      </object>
      <a className="resume-open" href="/resume.pdf" target="_blank" rel="noopener noreferrer">
        Open the resume in a new tab
      </a>
    </section>
  </>
);

function App() {
  const [hash, setHash] = useState(window.location.hash);
  const entry = ENTRIES.find((e) => `#/${e.id}` === hash);

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useLayoutEffect(() => {
    const { style } = document.documentElement;
    Object.entries(THEME_VARS).forEach(([key, cssVar]) => {
      if (entry && entry.theme[key]) {
        style.setProperty(cssVar, entry.theme[key]);
      } else {
        style.removeProperty(cssVar);
      }
    });
  }, [entry]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = entry ? `${entry.org} | ${NAME}` : NAME;
  }, [entry]);

  return (
    <div className="page">
      <header className="top">
        <a className="top-name" href="#/">
          {NAME}
        </a>
        <nav aria-label="Links">
          <a href="/resume.pdf" target="_blank" rel="noopener noreferrer">
            Resume
          </a>
          <a href="https://www.linkedin.com/in/akankshd/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <a href="https://github.com/akankshd" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </nav>
      </header>

      <main>{entry ? <ExperiencePage entry={entry} /> : <Home />}</main>

      <footer className="footer">
        <a href="mailto:akankshdivyananda@gmail.com">akankshdivyananda@gmail.com</a>
      </footer>
    </div>
  );
}

export default App;
